// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__tZ8Ed","overflowing":"ReadFullNote_overflowing__2JKru"};